import React from 'react';
import { get } from 'lodash';
import SelectField from '../../../../components/forms/SelectField';
import { CONTRACT_TYPES } from '../../../../constants/settings';
import { filtersSelector } from '../../../../selectors/admin/tables';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    canAccessClearanceInAdminSelector,
    canAccessPerformanceInAdminSelector,
    preferencesSelector
} from '../../../../selectors/authentication';
import { formDataSelector } from '../../../../selectors/admin/forms';
import { MODELS } from '../../../../constants/admin/settings';
import { savePreferences } from '../../../../actions/authentication';

const FILTER_OPTIONS = [{ label: 'General', value: 'OTHERS' }];

const OPTION_PERFORMANCE = { label: 'Performance contracts', value: CONTRACT_TYPES.PERFORMANCE };

const OPTION_CLEARANCE = { label: 'Clearance contracts', value: CONTRACT_TYPES.CLEARANCE };

const EventMailsFilter = ({
    filters = {},
    preferences = {},
    updateFilter,
    savePreferences: savePrefs,
    canAccessClearance,
    canAccessPerformance,
    event
}) => {
    const mailType = get(preferences, 'eventEmails.mailType') || filters.mailType || 'OTHERS';
    const handleChange = (value, name) => {
        updateFilter(value, name);
        savePrefs('eventEmails', { mailType: value });
    };
    return (
        <div className="ckp-admin-search-form ckp-grid-row">
            <SelectField
                onChange={handleChange}
                className="u-margin-right-3"
                label="Type filter"
                name="mailType"
                items={[
                    ...(canAccessClearance ? [OPTION_CLEARANCE] : []),
                    ...(canAccessPerformance && event.allowPerformanceContracts ? [OPTION_PERFORMANCE] : []),
                    ...FILTER_OPTIONS
                ]}
                value={mailType}
            />
        </div>
    );
};

const mapStateToProps = state => ({
    filters: filtersSelector(state),
    preferences: preferencesSelector(state),
    canAccessClearance: canAccessClearanceInAdminSelector(state),
    canAccessPerformance: canAccessPerformanceInAdminSelector(state),
    event: formDataSelector(state, { model: MODELS.EVENT })
});

const mapDispatchToProps = dispatch => bindActionCreators({ savePreferences }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventMailsFilter);
